import { createStylesMap } from 'app/theme/materialTheme';

export const styles = createStylesMap({
  bannerBackground: (theme) => ({
    textAlign: 'center',
    backgroundColor: theme.palette.error.light,
    p: '8px',
  }),
  bannerText: (theme) => ({
    color: theme.palette.error.contrastText,
  }),
});
